import React from 'react'
import AnalyticsPage from './AnalyticsPage';

export default function AnalyticsPagesContainer({form, data}) {
    if(form.pages)
        return (
            <div>
                {
                    form.pages.map((page)=><AnalyticsPage key={page.sectionId} page={page} data={data}></AnalyticsPage>)
                }                
            </div>
        )
    return null;
}
